import * as React from 'react';
import * as Header from '../constants/Header';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/settings.css';

import ForgotPasswordCodeForm from '../containers/ForgotPasswordCodeForm';

class DoneForgotPasswordCode extends React.Component {
  render() {
    return (
      <div>
        <div id="procedureFinished" className="forgotPassword">
          <h2>パスワード再設定が完了しました。</h2>
        </div>
      </div>
    );
  }
}

interface ForgotPasswordCodeProps extends React.Props<{}> {
  headerActions?: any;
  password: any;
  passwordActions: any;
}

class ForgotPasswordCode extends React.Component<ForgotPasswordCodeProps, {}> {
  static propTypes = {
    password: PropTypes.any.isRequired,
    passwordActions: PropTypes.any.isRequired,
  };

  constructor (props: any) {
    super(props);
  }

  componentWillMount() {
    document.title = '管理';
    this.props.headerActions.setPage(Header.SETTING_FORGOT_PASSWORD);
  }

  render() {
    return (
      <div>
        {
          (() => {
            if (this.props.password.Loaded) {
              return;
            }

            // ローディング中
            return <div><div id="loader" /><div id="loader_back" /></div>;
          })()
        }
        {(this.props.password.Loaded) ? (
          (this.props.password.result) ?
            <DoneForgotPasswordCode key="message" /> : <ForgotPasswordCodeForm key="form" />
          ) :
            (null)
        }
      </div>
    );
  }
}

export default ForgotPasswordCode;



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordCode.tsx